import './searchbar.css';
import Flaticon from "../flaticon/flaticon";

import {useState} from "react";
import LoaderScreen from "../LoaderScreen/LoaderScreen";

function Searchbar(props) {

    const zoom = 12;
    const [isLoading,setIsLoading] = useState(false)
    const handleSearchSubmit = async (e) => {
        e.preventDefault()
        if (e.target[0].value !== '') {
            setIsLoading(true);
            const response = await fetch(`https://api-adresse.data.gouv.fr/search/?q=${e.target[0].value}`);
            if(!response.ok) {
                setIsLoading(false)
                return;
            }
            const data = await response.json();

            if (data.features.length !== 0) {
                setIsLoading(false);
                props.map.setView([data.features[0].geometry.coordinates[1],data.features[0].geometry.coordinates[0]],zoom);
            } else {
                setIsLoading(false)
            }
        }

    }
    return (
        <div className={`searchbar ${props.className}`}>
            <form onSubmit={handleSearchSubmit} action="" className={'searchbar-form'}>
                {isLoading ? <LoaderScreen/> : ''}
                <input placeholder={`Rechercher une adresse...`} id={'searchbar'} type="text" className={'slo-search searchbar-form-item'}/>
                <button className={'slo-btn search-submit searchbar-form-item'} type="submit" >{isLoading ? <Flaticon icon={'searching-magnifier'}/> : <Flaticon icon={'magnifier'}/>}</button>
            </form>
        </div>
    );
}

export default Searchbar;
